const defaultState = {};

const reduce = (state = defaultState, { type, payload }) => {
  switch (type) {
    case 'set_loan_schema':
      return payload;
    default:
      return state;
  }
};

export default reduce;
